module.exports = __webpack_public_path__ + "static/media/payment_upon_purchase.51572943.svg";